import React, { useEffect, useState } from "react";
import HeaderDashboard from "../../Components/HeaderDashboard";
import { useLocation } from "react-router-dom";
import { GetTransactionDetails } from "../../Services/InsuranceApi";
const InsTransactionsDetails = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    function getParamIgnoreCase(key) {
        for (const [k, v] of queryParams.entries()) {
            if (k.toLowerCase() === key.toLowerCase()) {
                return v;
            }
        }
        return null;
    }
    const referenceNo = getParamIgnoreCase("ReferenceNo");
    const key = getParamIgnoreCase("Key");
    const clientCode = getParamIgnoreCase("ClientCode");

    const [transactionData, setTransactionData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        if (referenceNo && key && clientCode) {
            fetchTransactionDetails(referenceNo, key, clientCode);
        } else {
            console.warn("Missing query parameters");
        }
    }, [referenceNo, key, clientCode]);

    const fetchTransactionDetails = async (referenceNo, key, clientCode) => {
        try {
            setLoading(true);
            setError("");
            const params = {
                ReferenceNo: referenceNo,
                Key: key,
                ClientCode: clientCode,
            };

            const response = await GetTransactionDetails(params);
            console.log("TransactionDetails:", response);
            setTransactionData(response);

        } catch (err) {
            setError("Failed to load Transaction details. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const booking =
        transactionData?.booking;

    const passengers =
        transactionData?.passengers || [];

    const payments =
        transactionData?.payments || [];

    const rider =
        transactionData?.rider || [];

    const formatDate = (dateStr) => {
        if (!dateStr) return "";

        return new Date(dateStr).toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    };

    const formatTime = (dateStr) => {
        if (!dateStr) return "";

        return new Date(dateStr).toLocaleTimeString("en-IN", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        });
    };

    return (
        <>
            {loading && (
                <p class="text-center load"><span class="loader"></span></p>
            )}
            <HeaderDashboard />
            <div className="toolbar py-2" id="kt_toolbar">
                <div id="kt_toolbar_container" className="container-fluid d-flex align-items-center">
                    <div className="flex-grow-1 flex-shrink-0 me-5">
                        <div data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}" className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
                            <h1 className="d-flex align-items-center text-gray-900 fw-bold my-1 fs-3">Reservations</h1>
                            <span className="h-20px border-gray-200 border-start mx-3"></span>
                            <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
                                <li class="breadcrumb-item text-muted">Insurance</li>
                                <li class="breadcrumb-item">
                                    <span class="bullet bg-gray-200 w-5px h-2px"></span>
                                </li>
                                <li class="breadcrumb-item text-gray-900">Transaction Details</li>
                            </ul>
                        </div>
                    </div>
                    <div class="d-flex align-items-center flex-wrap">
                        <div class="flex-shrink-0 me-2 d-none-mob">
                            <ul class="nav" role="tablist">
                                <li class="nav-item" role="presentation">
                                    <a href="#" onClick={(e) => { e.preventDefault(); window.history.back(); }} >
                                        <img src="/assets/images/back.png" width={30} />
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>


            <section className="wraper">

                <div className="box_shadow mt-14">
                    <div class="row mamage_depo">
                        <div class="col-lg-6">
                            <h6 className='ruler'>Insurance Booking Details</h6>
                        </div>

                        <div class="col-lg-6 text-right">
                            <ul className="option_s">


                                <li>
                                    <button
                                        type="button"
                                        onClick={() => {
                                            window.open(
                                                //   `/reservations/bus/PrintInvoice?ReferenceNo=${booking?.referenceNo}&clientCode=${clientCode}&key=${key}`,
                                                `/reservations/insurance/InsPrintInvoice?referenceNo=${transactionData?.referenceNo}&key=${transactionData?.key}&clientCode=${transactionData?.clientCode}`,
                                                "_blank"
                                            );
                                        }}
                                        style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
                                        title="Invoice"
                                    >
                                        <img src="/assets/images/Invoice.png" alt="Invoice" />
                                    </button>
                                </li>

                                <li>
                                    <a
                                        href={`/reservations/insurance/InsCancellationBooking?referenceNo=${transactionData?.referenceNo}&key=${transactionData?.key}&clientCode=${transactionData?.clientCode}`}
                                    >
                                        <img
                                            title="Cancel Booking"
                                            alt="Cancel Booking"
                                            src="/assets/images/ticket.png"
                                        />
                                    </a>
                                </li>

                            </ul>


                        </div>

                    </div>
                    {/* BOOKING DETAILS */}

                    <div className="col-md-12 col-lg-12">
                        <table className="table table-bordered responsive-table">
                            <thead>
                                <tr>
                                    <th>Reference No</th>
                                    <th>Policy No</th>
                                    <th>Booking Status</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr>
                                    <td>{booking?.referenceNo}</td>
                                    <td>{booking?.policyNumber}</td>
                                    <td>
                                        <span
                                            style={{
                                                color: booking?.bookingStatus === "Confirmed" ? "green" : "red",
                                            }}
                                        >
                                            <b>{booking?.bookingStatus}</b>
                                        </span>
                                    </td>
                                    <td>{booking?.startDate}</td>
                                    <td>{booking?.endDate}</td>
                                </tr>
                            </tbody>

                        </table>

                    </div>

                    {/* PASSENGER DETAILS */}
                    <div className='col-md-12 col-lg-12'>
                        <h6 className='ruler'>Policy Details</h6>
                        <div className='table-responsive'>
                            <table className="table table-bordered responsive-table">
                                <thead>
                                    <tr>
                                        <th>Policy No</th>
                                        <th>Category Name</th>
                                        <th>Insurer Name</th>
                                        <th>Supplier</th>
                                        <th>Start Date</th>
                                        <th>End Date</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{booking?.policyNumber}</td>
                                        <td>{booking?.categoryName}</td>
                                        <td>{booking?.insuranceName}</td>
                                        <td>{booking?.supplierName}</td>
                                        <td>{booking?.startDate}</td>
                                        <td>{booking?.endDate}</td>
                                        <td>{booking?.bookingStatus}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    {booking?.bookingStatus === "Confirmed" && (
                        <div className='col-md-12 col-lg-12'>
                            <h6 className='ruler'>Cart Amendments</h6>
                            <div className="row">

                                <div class="col-md-3"><div class="box_shadows"><div>
                                    <a href={`/reservations/insurance/InsPrintInvoice?referenceNo=${transactionData?.referenceNo}&key=${transactionData?.key}&clientCode=${transactionData?.clientCode}`}>
                                        <h5><img alt="Invoice" src="/assets/images/Invoice.png" /> Invoice</h5>
                                        <p>View &amp; Manage the Invoice for flight booking ticket.</p>
                                        <button class="btn-raise" type="button">View Invoice</button>
                                    </a>
                                </div></div></div>
                                {/* <div class="col-md-3"><div class="box_shadows">
                                    <div class="w-100 d-block"><h5>
                                        <img alt="Download Ticket" src="/assets/images/Download.png" /> Download Policy</h5>
                                        <p>Download the copy of your flight ticket.</p>
                                        <button class="btn-raise" type="button">Download</button>
                                    </div></div></div> */}
                                <div class="col-md-3"><div class="box_shadows">
                                    <a href={`/reservations/insurance/InsCancellationBooking?referenceNo=${transactionData?.referenceNo}&key=${transactionData?.key}&clientCode=${transactionData?.clientCode}`} class=""><h5>
                                        <img title="Cancel Booking" alt="Cancel Booking" src="/assets/images/ticket.png" /> Cancel Policy</h5>
                                        <p>Check cancellation charges and refund eligibility before request</p>
                                        <button class="btn-raise">Cancel Booking</button>
                                    </a>
                                </div>
                                </div>
                            </div>
                        </div>
                    )}
                    <div className='col-md-12 col-lg-12 mt-12'>
                        <h6 className='ruler'>Contact Information</h6>
                        <div className='table-responsive'>
                            <table className="table table-bordered responsive-table">
                                <thead>
                                    <tr>
                                        <th>Mobile Number</th>
                                        <th>Email Address</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{booking?.emailId}</td>
                                        <td>{booking?.mobileNo}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="col-md-12 col-lg-12">

                        <h6 className="ruler">
                            Passenger Information
                        </h6>

                        <div className="table-responsive">
                            <table className="table table-bordered responsive-table">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Passenger Name</th>
                                        <th>Date of Birth</th>
                                        <th>Gender</th>
                                        <th>Policy No</th>
                                        {booking?.bookingStatus === "Confirmed" && (
                                            <th>Palicy Document</th>
                                        )}
                                        <th>Status</th>
                                        <th>Nominee</th>
                                        <th>Relation</th>
                                        <th>Passport</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {passengers.map(
                                        (item, index) => (
                                            <tr key={index}>

                                                <td>{index + 1}</td>
                                                <td>
                                                    {item?.title}{" "}
                                                    {item?.firstName}{" "}
                                                    {item?.lastName}
                                                </td>

                                                <td>
                                                    {item?.dob}
                                                </td>

                                                <td>
                                                    {item?.gender}
                                                </td>
                                                <td>
                                                    {item?.policyNo}
                                                </td>
                                                {booking?.bookingStatus === "Confirmed" && (
                                                    <td>
                                                        <a
                                                            href={item?.policyPath}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="btn btn-primary btn-sm"
                                                        >
                                                            Download Policy
                                                        </a>
                                                    </td>
                                                )}
                                                <td>
                                                    {item?.bookingStatus}
                                                </td>
                                                <td>
                                                    {item?.nominee}
                                                </td>
                                                <td>
                                                    {item?.relation}
                                                </td>
                                                <td>
                                                    {item?.passport}
                                                </td>
                                            </tr>
                                        )
                                    )}

                                </tbody>

                            </table>

                        </div>

                    </div>

                    {/* PAYMENT DETAILS */}

                    <div className="col-md-12 col-lg-12">

                        <h6 className="ruler">
                            Transaction Summary
                        </h6>

                        <div className="table-responsive">

                            <table className="table table-bordered responsive-table">

                                <thead>
                                    <tr>
                                        <th>Payment Status</th>
                                        <th>Transaction ID</th>
                                        <th>Amount Paid</th>
                                        <th>Payment Date</th>
                                    </tr>
                                </thead>

                                <tbody>

                                    {payments.map(
                                        (item, index) => (
                                            <tr key={index}>

                                                <td>
                                                    {item?.paymentStatus}
                                                </td>

                                                <td>
                                                    {item?.transactionID}
                                                </td>

                                                <td>
                                                    ₹ {item?.amountPaid}
                                                </td>

                                                <td>
                                                    {item?.creationDate
                                                        ? new Date(item.creationDate).toLocaleString("en-IN", {
                                                            day: "2-digit",
                                                            month: "2-digit",
                                                            year: "numeric",
                                                            hour: "2-digit",
                                                            minute: "2-digit",
                                                            second: "2-digit",
                                                            hour12: true,
                                                        })
                                                        : "-"}
                                                </td>

                                            </tr>
                                        )
                                    )}

                                </tbody>

                            </table>

                        </div>

                    </div>

                    {/* RIDER DETAILS */}

                    <div className="col-md-12 col-lg-12">

                        <h6 className="ruler">
                            Rider Information
                        </h6>

                        <div className="table-responsive">

                            <table className="table table-bordered responsive-table">

                                <thead>
                                    <tr>
                                        <th>Rider Name</th>
                                        <th>Rate Type</th>
                                        <th>Percent</th>
                                        <th>Amount</th>
                                    </tr>
                                </thead>

                                <tbody>

                                    {rider.map(
                                        (item, index) => (
                                            <tr key={index}>

                                                <td>
                                                    {item?.riderName}
                                                </td>

                                                <td>
                                                    {item?.rateType}
                                                </td>

                                                <td>
                                                    {item?.percent}%
                                                </td>

                                                <td>
                                                    ₹ {item?.riderAmount}
                                                </td>

                                            </tr>
                                        )
                                    )}

                                </tbody>

                            </table>

                        </div>

                    </div>
                    <div className='col-md-12 col-lg-12'>
                        <h6 className='ruler'>GST Details</h6>
                        <div className='table-responsive'>
                            <table className="table table-bordered responsive-table">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Number</th>
                                        <th>Phone	</th>
                                        <th>Email</th>
                                        <th>Address</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            {transactionData?.gstDetails?.name}
                                        </td>
                                        <td>
                                            {transactionData?.gstDetails?.gstNumber}
                                        </td>
                                        <td>
                                            {transactionData?.gstDetails?.contactNo}
                                        </td>
                                        <td>
                                            {transactionData?.gstDetails?.email}
                                        </td>
                                        <td>
                                            {transactionData?.gstDetails?.address}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className='col-md-12 col-lg-12'>
                        <h6 className='ruler'>User Details</h6>
                        <div className='table-responsive'>
                            <table className="table table-bordered responsive-table">
                                <thead>
                                    <tr>
                                        <th>Booking Created By</th>
                                        <th>Booking Created On</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{booking?.createdBy}</td>
                                        <td>{booking?.createdOn}</td>

                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="col-lg-12 important_info">
                        <h4>IMPORTANT INFORMATION</h4>
                        <ul className="policy_info_list">

                            <li>
                                Please verify all passenger and travel details carefully.
                            </li>

                            <li>
                                Insurance policy once issued may not be refundable.
                            </li>

                            <li>
                                Coverage is subject to insurer terms and conditions.
                            </li>

                            <li>
                                Pre-existing medical conditions may not be covered unless specified.
                            </li>

                            <li>
                                Carry a copy of your policy certificate while travelling.
                            </li>

                            <li>
                                In case of emergency, contact the insurer support immediately.
                            </li>

                            <li>
                                Claims are subject to document verification and insurer approval.
                            </li>

                            <li>
                                Please check policy validity dates before departure.
                            </li>

                            <li>
                                GST and other applicable charges are included as per regulations.
                            </li>

                            <li>
                                For any support, contact Berry Journeys customer assistance.
                            </li>

                        </ul>
                    </div>
                </div>

            </section>

        </>
    );
};

export default InsTransactionsDetails;